import * as React from 'react';
import { useMediaQuery } from 'react-responsive';

import { Breakpoint, DirectionEnum } from '../../enums';
import { Button } from '../button/button.component';

import { Container, Description, ImageElement, ImageContainer, NewsContainer, Title } from './newsSection.styled';
import { NewsSectionProps } from './newsSection.types';

export const NewsSection: React.FC<NewsSectionProps> = (props: NewsSectionProps): JSX.Element => {
  const { title, description, buttonLabel, buttonAction, image, imagePosition = DirectionEnum.Right, className }: NewsSectionProps = props;
  const isMobile: boolean = useMediaQuery({ query: Breakpoint.Mobile });

  return (
    <Container className={className} $imagePosition={imagePosition}>
      <NewsContainer $imagePosition={imagePosition}>
        <Title>{title}</Title>
        <Description text={description} />
        {!!buttonLabel && !!buttonAction && (
          <Button label={buttonLabel} onClick={buttonAction} fullWidth={isMobile} />
        )}
      </NewsContainer>
      <ImageContainer>
        <ImageElement src={image} alt={title} />
      </ImageContainer>
    </Container>
  );
};
